'use-strict'

import { clearNonDigitalCharacters } from "../utilities/utilities";

function quantityCounterActions() {

	$(document).on('click', '.qnt-counter__button--minus', function() {
		onClickQuantityCounterMinus( $(this) );
	});

	$(document).on('click', '.qnt-counter__button--plus', function() {
		onClickQuantityCounterPlus( $(this) );
	});

	$(document).on('change', '.qnt-counter__input', function() {
		onChangeQuantityCounterInput( $(this) );
	});

	$('.qnt-counter__input').each(function() {
		onChangeQuantityCounterInput( $(this) );
	});
	
}

function onClickQuantityCounterMinus( target ) {

	const container = target.parent();
	const input = target.siblings('.qnt-counter__input');
	const plus  = target.siblings('.qnt-counter__button--plus');

	const min = typeof container.data('min') === 'undefined' || parseInt(container.data('min')) < 1 ? 1 : parseInt(container.data('min'));

	let newValue = parseInt(input.val()) - 1;
	
	if ( newValue < min ) newValue = min;

	if ( newValue === min ) target.attr('disabled', true);
	plus.removeAttr('disabled');
	input.val(newValue).trigger('change');
	// onChangeQuantityCounterInput(input);
	
}

function onClickQuantityCounterPlus( target ) {
	
	const container = target.parent();
	const input = target.siblings('.qnt-counter__input');
	const minus  = target.siblings('.qnt-counter__button--minus');
	
	const max = typeof container.data('max') === 'undefined' || parseInt(container.data('max')) < 1 ? 0 : parseInt(container.data('max'));
	
	let newValue = parseInt(input.val()) + 1;
	
	if ( max > 0 && newValue > max ) newValue = max;
	
	if ( newValue === max ) target.attr('disabled', true);
	minus.removeAttr('disabled');
	input.val(newValue).trigger('change');
	// onChangeQuantityCounterInput(input);
	
}

function onChangeQuantityCounterInput( target ) {

	const container = target.parent();
	const minus  = target.siblings('.qnt-counter__button--minus');
	const plus  = target.siblings('.qnt-counter__button--plus');

	const min = typeof container.data('min') === 'undefined' || parseInt(container.data('min')) < 1 ? 1 : parseInt(container.data('min'));
	const max = typeof container.data('max') === 'undefined' || parseInt(container.data('max')) < 1 ? 0 : parseInt(container.data('max'));

	let newValue = parseInt(clearNonDigitalCharacters(target.val()));
	
	if ( isNaN(newValue) || newValue <= min ) {

		newValue = min;
		minus.attr('disabled', true);
		plus.removeAttr('disabled');
		
	} else if ( max > 0 && parseInt(target.val()) >= max ) {

		newValue = max;
		plus.attr('disabled', true);
		minus.removeAttr('disabled');
		
	} else {

		plus.removeAttr('disabled');
		minus.removeAttr('disabled');
		
	}

	target.val(newValue);
	
}

export {
	quantityCounterActions,
	onClickQuantityCounterMinus,
	onClickQuantityCounterPlus,
	onChangeQuantityCounterInput,
};